<template>
  <div 
    class="img-table-cell">
    <el-image 
      v-if="src"
      :preview-src-list="[src]" 
      :src="src"/>
    <span 
      v-else 
      class="no-data">
      暂无图像
    </span>
  </div>
</template>

<script>
export default {
  props: {
    src: String
  }
}
</script>

<style lang="scss" scoped>
.img-table-cell{
  display: flex;
  justify-content: center;
  .el-image{
    width: 100%;
    height: 100%;
    >>> img{
      object-fit: contain;
      max-height: 5.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TableCell/Img.vue